import {IntermediatePart} from "../../intermediatePart";

export default class Stove extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'stove';
    this.partName = 'Stove';
    this.translateId = "visualizer.kitchen.appliance.stove";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Stove());
  }

  handleClick(ignoreLocked, clickFrom = "") {
    const applianceParent = this.getParent().getParent();
    if (applianceParent && applianceParent.hood && applianceParent.hood.activeFeature) {
      const currentHoodWidth = applianceParent.hood.activeFeature.metaData["Width"];
      const newWidth = this.metaData["Width"];
      if (newWidth && (!currentHoodWidth || (newWidth[0] !== currentHoodWidth[0]))) {
        const currentHoodNavItems = applianceParent.hood.navigationSubItems();
        const sameWidth = currentHoodNavItems.filter(navItem => {
          if (!navItem.part.metaData["Width"]) {
            return false
          }
          if (newWidth[0] === "24") {
            return navItem.part.metaData["Width"][0] === newWidth[0] || navItem.part.metaData["Width"][0] === "30"
          }
          return navItem.part.metaData["Width"][0] === newWidth[0]
        });
        console.log("newWidth", newWidth[0]);
        console.log("sameWidth", sameWidth);
        if (sameWidth.length) { // here we can filter by the same name, color etc.
          applianceParent.hood.activeFeature = sameWidth[0].part;
        }
      }
    }
    super.handleClick(ignoreLocked, clickFrom);
  }

  disabledClick() {
    const hood = this.getParent().hood;
    if (hood) {
      hood.disabled = this.disabled;
    }
  }

}
